const flatProductList = (productGroup, list = []) => {
  const products = (productGroup.products || []).map(p => {
    p.groupType = productGroup.name;
    return p;
  });
  return (productGroup.groups || []).length
    ? productGroup.groups.map(g => flatProductList(g, products)).flat()
    : list.concat(products);
};

export {
  flatProductList as default,
  flatProductList
};
